<template>
  <div>
    <a-modal v-drag-modal wrap-class-name="custom-modal-wrap" v-model="visible" :width="560" :confirmLoading="loading"
      :maskClosable="false" @cancel="cancel" @ok="confirm" :style="{ maxHeight: '80vh', overflow: 'auto' }">
      <div slot="title">{{ form.id ? '编辑角色' : '新增角色' }}</div>
      <div class="modal-content">
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
          <!-- <a-button type="link" @click="debugPermissions" style="margin-bottom: 10px">调试权限数据</a-button> -->
          <a-form-model-item prop="name" label="名称">
            <a-input v-model="form.name" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-input v-model="form.remark" allowClear />
          </a-form-model-item>

          <!-- <a-checkbox-group v-model="form.permissions">
            <a-descriptions size="small" title="权限" bordered>
              <a-descriptions-item v-for="permissionTypeItem in $parent.permissionItems" :key="permissionTypeItem.id" :label="permissionTypeItem.name" :span="3">
                <a-row>
                  <a-col v-for="item in permissionTypeItem.permission_items" :key="item.id" :span="24">
                    <a-checkbox :value="item.id">{{ item.name }}</a-checkbox>
                  </a-col>
                </a-row>
              </a-descriptions-item>
            </a-descriptions>
          </a-checkbox-group> -->


          <a-checkbox-group v-model="form.permissions">
            <a-descriptions size="small" title="权限" bordered>
              <a-descriptions-item v-for="permissionTypeItem in $parent.permissionItems" :key="permissionTypeItem.id"
                :span="3">
                <div slot="label" style="width: 90px">
                  <a-checkbox :value="permissionTypeItem.name" @change="checkAll">{{
                    permissionTypeItem.name
                  }}</a-checkbox>
                </div>
                <a-row>
                  <a-col v-for="item in permissionTypeItem.permission_items" :key="item.id" :span="8">
                    <a-checkbox :value="item.id">{{ item.name }}</a-checkbox>
                  </a-col>
                </a-row>
              </a-descriptions-item>
            </a-descriptions>
          </a-checkbox-group>

          <!-- <a-form-model-item prop="permissions" label="角色权限">
            <a-tree-select v-model="form.permissions" placeholder="请选择权限" :tree-data="permissionsTree" tree-checkable
              treeDefaultExpandAll style="width: 100%">
            </a-tree-select>
          </a-form-model-item> -->
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { roleCreate, roleUpdate } from '@/api/account'
import { permissionsTree } from '@/permissions.js'
import rules from './rules.js'

export default {
  name: 'FormModal',
  props: ['visible', 'form', 'roleName'],
  model: { prop: 'visible', event: 'cancel' },
  data() {
    return {
      rules,
      loading: false,
      permissionsTree,
      isUpdatingPermissions: false, // 防止循环更新的标志
    };
  },
  watch: {
    // 监听对话框打开，自动补充缺失的父权限
    visible(newVal) {
      if (newVal && this.form.permissions) {
        this.$nextTick(() => {
          this.initializeParentPermissions();
        });
      }
    },
    // 深度监听权限数组的变化，自动处理父子权限关系
    'form.permissions': {
      handler(newVal) {
        if (!this.$parent.permissionItems || !newVal) {
          return;
        }
        this.syncParentPermissions();
      },
      deep: true
    }
  },
  methods: {
    // debugPermissions() {
    //   console.log('父组件权限项目:', this.$parent.permissionItems);
    //   console.log('当前选中的权限:', this.form.permissions);
    // },
    // 初始化时检查并补充缺失的父权限
    initializeParentPermissions() {
      if (!this.$parent.permissionItems || !this.form.permissions) {
        return;
      }
      
      for (let parentPermission of this.$parent.permissionItems) {
        const parentName = parentPermission.name;
        const parentIndex = this.form.permissions.indexOf(parentName);
        
        // 检查该父权限下是否有任何子权限被勾选
        const hasCheckedChild = parentPermission.permission_items.some(item => 
          this.form.permissions.includes(item.id)
        );
        
        // 如果有子权限被勾选，但父权限未勾选，则自动勾选父权限
        if (hasCheckedChild && parentIndex === -1) {
          this.form.permissions.push(parentName);
        }
      }
    },
    // 同步父权限状态（勾选子权限时自动勾选父权限，取消所有子权限时自动取消父权限）
    syncParentPermissions() {
      if (!this.$parent.permissionItems || !this.form.permissions || this.isUpdatingPermissions) {
        return;
      }
      
      let needUpdate = false;
      const newPermissions = [...this.form.permissions];
      
      for (let parentPermission of this.$parent.permissionItems) {
        const parentName = parentPermission.name;
        const parentIndex = newPermissions.indexOf(parentName);
        
        // 检查该父权限下是否有任何子权限被勾选
        const hasCheckedChild = parentPermission.permission_items.some(item => 
          newPermissions.includes(item.id)
        );
        
        // 如果有子权限被勾选，但父权限未勾选，则自动勾选父权限
        if (hasCheckedChild && parentIndex === -1) {
          newPermissions.push(parentName);
          needUpdate = true;
        } 
        // 如果没有子权限被勾选，但父权限已勾选，则自动取消父权限
        else if (!hasCheckedChild && parentIndex !== -1) {
          newPermissions.splice(parentIndex, 1);
          needUpdate = true;
        }
      }
      
      // 只有在需要更新时才更新，避免触发无限循环
      if (needUpdate) {
        this.isUpdatingPermissions = true;
        this.form.permissions = newPermissions;
        this.$nextTick(() => {
          this.isUpdatingPermissions = false;
        });
      }
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;

          let permissions = [];
          for (let value of this.form.permissions) {
            if (typeof value == "number") {
              permissions.push(value);
            }
          }

          let func = this.form.id ? roleUpdate : roleCreate;
          func({ ...this.form, permissions }).then(data => {
            this.$message.success(this.form.id ? '修改成功' : '新增成功');
            this.$emit(this.form.id ? 'update' : 'create', data);
            this.cancel();
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    cancel() {
      this.$emit('cancel', false);
      this.$refs.form.resetFields();
    },
    checkAll(event) {
      for (let item of this.$parent.permissionItems) {
        if (item.name == event.target.value) {
          for (let permissionItem of item.permission_items) {
            let index = this.form.permissions.indexOf(permissionItem.id);

            if (event.target.checked && index == -1) {
              this.form.permissions.push(permissionItem.id);
            } else if (!event.target.checked && index != -1) {
              this.form.permissions.splice(index, 1);
            }
          }
          break;
        }
      }
    },
  },
}
</script>

<style scoped>
.modal-content {
  max-height: 70vh;
  overflow-y: auto;
}

:deep(.custom-modal-wrap .ant-modal) {
  top: 50px;
  padding-bottom: 50px;
}

:deep(.custom-modal-wrap .ant-modal-body) {
  max-height: calc(80vh - 110px);
  overflow-y: auto;
}
</style>